import companyCardService from './companyCardService'

export default companyCardService
